module.exports = __webpack_public_path__ + "img/PhoneMockup.09f56472.png";